import LogoutIcon from '@mui/icons-material/Logout';
import { Box, IconButton, Stack, Tooltip } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import React, { PropsWithChildren, ReactNode } from 'react';

import { logout } from '@/api/util/logoutRequest.util.ts';
import { useGetEnv } from '@/api/util/useGetEnv.util.ts';
import { BackgroundBranding } from '@/layouts/private/background/BackgroundBranding.comp.tsx';
import {
  getLayoutContainerStyles,
  LayoutMainStyles,
  LayoutShellStyles,
  LayoutStyles,
} from '@/layouts/private/Layout.styles.ts';
import { Logo } from '@/layouts/private/logo/Logo.comp.tsx';
import { EnvironmentBanner } from '@/layouts/private/topBar/components/EnvironmentBanner.comp.tsx';
import TopMenuTabs from '@/layouts/private/topBar/components/TopMenuTabs.comp.tsx';
import TopBarNavigation from '@/layouts/private/topBar/TopBarNavigation.comp.tsx';
import { PATHS_WITHOUT_SESSION } from '@/routes/RoutesNotRequiringAuth.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

const Layout: React.FC<{ addons?: ReactNode } & PropsWithChildren> = ({ children }) => {
  const { env } = useGetEnv();
  const { t } = useTranslationWithPrefix('layouts');
  const hasEnvironmentBanner = env?.env === 'dev' || env?.env === 'preview';

  const handleLogout = async () => {
    await logout();
  };

  if (PATHS_WITHOUT_SESSION) {
    return (
      <>
        <CssBaseline />
        {children}
      </>
    );
  }

  return (
    <Stack sx={LayoutStyles}>
      <CssBaseline />
      <BackgroundBranding />
      <Stack sx={LayoutShellStyles}>
        <EnvironmentBanner />
        <Stack alignItems="center" direction="row" justifyContent="space-between">
          <Stack alignItems="center" direction="row" spacing={5}>
            <TopBarNavigation>
              <Logo />
              <TopMenuTabs />
            </TopBarNavigation>
          </Stack>
          <IconButton onClick={handleLogout} sx={{ mr: 3 }}>
            <Tooltip title={t('logout.tooltip')}>
              <LogoutIcon />
            </Tooltip>
          </IconButton>
        </Stack>
        <Box sx={getLayoutContainerStyles(hasEnvironmentBanner)}>
          <Stack direction="row" sx={LayoutMainStyles}>
            {children}
          </Stack>
          {/* <Footer />*/}
        </Box>
      </Stack>
    </Stack>
  );
};

export default Layout;
